// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/tradable_area_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { TradableAreaService } from "./tradable_area_service_pb";

/**
 * ListTradableAreas returns, for each 発注主体区分, the areas whose
 * 受渡契約コード resolves from the organization's OCCTO masters on the
 * 受渡日, and the subset the bidding screens let the user pick. The bidding
 * screens build the 発注主体 selector and gate per-area actions from it.
 *
 * @generated from rpc bffuser.v1.TradableAreaService.ListTradableAreas
 */
export const listTradableAreas = TradableAreaService.method.listTradableAreas;
